import Section from '../components/Section/Section';
import styles from './Ticket.module.css';
import Dropdown from 'react-dropdown'
import { Hint } from 'react-autocomplete-hint';
//import { Fade } from "react-awesome-reveal";
import React, {useState, useEffect, useRef} from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import LineworxClient from '../lineworxClient';

import ErrorBoundary from '../ErrorBoundary';
import { toDateInputValue } from '../utils/dateUtils';

const TicketHome = (props) => {

    const {
        active,
        //jobNumber,
        //ticket,
        pole = {},
        activePoleDirty,
        addPoleError,
        //changePoleText,
        //changeLineText,
        needsMerge,
        mergeTickets,
        //subStations,
        changePoleAddress,
        accessTypesForDropdown,
        //changeSubStationText,
        //changeCurcuitText,
        //showStationSelections,
        //showSavePoleChanges,
        savePole,
        saving,
        arcRatingChange,
        secondaryVoltageChange,
        primaryVoltageChange,
        latitudeChange,
        longitudeChange,
        handleSelectAccessType,
        //getSpecificPole,
        //specHintData,
        //specText,
        setSpecText,
        changePoleOnTicket,
        sortPoles,
        setPoleSort,
        sortPoleAsc, 
        setSortPoleAsc,
        utilsForDropdown,
        job,
        resetPoleId,
        changePoleId,
        changeLineId,
        changeDueDate,
        handleTicketSelectUtility
    } = props;

    const [utilityForPoleView, setUtilityForPoleView] = useState({})
    const [potentialPoles, setPotentialPoles] = useState([]);
    const [searchPoleText, setSearchPoleText] = useState('');
    const [searchLineText, setSearchLineText] = useState('');
    const [dueDate, setDueDate] = useState(props.ticket?.due_date || '');
    const [poleIdText, setPoleIdText] = useState('');
    const [lineIdText, setLineIdText] = useState('');

    const utilsForSearch = [{label:"All", value:-1}, ...utilsForDropdown];
    const prevPoleRef = useRef();

    useEffect(() => {
        setUtilityForPoleView(job ? {value:job.selected_utility_id, label:job.selected_utility_name} : {});
    }, [job]);

    useEffect(() => {
        resetPoleId();
    }, [searchPoleText, searchLineText, resetPoleId]);

    useEffect(() => {
        setDueDate(props.ticket?.due_date || '');
    }, [props.ticket]);

    useEffect(() => {
        const prevPole = prevPoleRef.current;
        const currentPole = pole;
        
        if (prevPole && prevPole.id && (!currentPole || !currentPole.id)) {
            setSearchPoleText('');
            setSearchLineText('');
            setPoleIdText('');
            setLineIdText('');
            setPotentialPoles([]);
        }
        
        prevPoleRef.current = currentPole;
    }, [pole]);

    const handleDueDateChange = (e) => {
        const newValue = e.target.value;
        setDueDate(newValue);
        if (changeDueDate) {
            changeDueDate(newValue);
        }
    };

    const searchPoles = async () => {
      let utility = '';
      if (utilityForPoleView?.label !== 'All')  utility = utilityForPoleView.label;
console.log(utility, searchPoleText, searchLineText);
      let pPoles = await LineworxClient.getPolesByUtility(utility, searchPoleText, searchLineText);
      if(pPoles.response.ok) {
          setPotentialPoles(pPoles.body.poles);
      }
    }

    // console.log(potentialPoles);
    const generateSortableTh = (sortName, displayName, classString, sortPoles, setSortPoles, sortAsc, setSortAsc) => {
        return <Th className={classString} 
            scope='col' 
            onClick={() => {sortPoles === sortName ? setSortAsc(!sortAsc) : setSortPoles(sortName)}}>
                <label  sortable='true'>{displayName}</label>  
                <svg className={(sortAsc ? "sort-asc" : "sort-desc") + (sortPoles === sortName ? "" : ' fade')} 
                version="1.1" id="Capa_1" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 292.362 292.362" fill="black">
                    <g><path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424   C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428   s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"/></g></svg>
            </Th>
    }

    const addPole = async () => {
      let utility = '';
      if (utilityForPoleView?.label !== 'All') {
        utility = utilityForPoleView.label;
      }
      console.log(`pole: ${searchPoleText}, line: ${searchLineText}, utility: ${utility}`);
      const response = await LineworxClient.addPoleByPoleLineUtil(searchPoleText, searchLineText, utility);
      if (response.response.ok) {
        const poleResponse = await LineworxClient.getExactPoleWUtility(utility, searchPoleText, searchLineText);
        if (poleResponse.response.ok) {
          changePoleOnTicket(poleResponse.body);
        }
      }
    };

    return (

        <div className={`tab-pane fade${active ? ' show active' : ''}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">        
            <ErrorBoundary>
            {/* section - Pole/ Line / Loc */}
                <div id={styles.poleLineLoc} className={`section noBorder ${styles.poleLineLoc}`}> 
                  {/* First row: Pole ID and Line ID */}
                  <div className="w-100 d-flex flex-row">
                    <div className={`col-sm-6 col-md-3 d-flex flex-column align-items-center align-items-sm-start justify-content-between pr-sm-4 pr-md-2 item itemPole ${styles.itemPole} ${styles.item}`}>
                      <label htmlFor='pole_id'>Pole ID</label>
                      <input
                        name='pole_id'
                        value={pole.pole_id || ''}
                        onChange={e => changePoleId(e.target.value)}
                        />
                    </div>
                    <div className={`col-sm-6 col-md-3 d-flex flex-column align-items-center align-items-sm-start justify-content-between pl-sm-4 pl-md-2 pr-md-2 item itemLine ${styles.itemLine} ${styles.item}`}>
                      <label htmlFor='line_id'>Line ID</label>
                      <input
                        name='line_id'
                        value={pole.id ? pole.line_id : lineIdText}
                        onChange={e => {
                          if (pole.id) {
                            changeLineId(e.target.value);
                          } else {
                            setLineIdText(e.target.value);
                            changeLineId(e.target.value);
                          }
                        }}
                         />
                    </div>
                  </div>
                  {/* Second row: Pole, Line, Utility, and Due Date */}
                  <div className="w-100 d-flex flex-row">
                    <div className={`col-sm-6 col-md-3 d-flex flex-column align-items-center align-items-sm-start justify-content-between pr-sm-4 pr-md-2 item itemPole ${styles.itemPole} ${styles.item}`}>
                      <label htmlFor='pole'>Pole</label>
                      <input
                        name='pole'
                        value={pole.id?pole.pole_name:searchPoleText}
                        onChange={e => setSearchPoleText(e.target.value)}
                        />
                    </div>
                    <div className={`col-sm-6 col-md-3 d-flex flex-column align-items-center align-items-sm-start justify-content-between pl-sm-4 pl-md-2 pr-md-2 item itemLine ${styles.itemLine} ${styles.item}`}>
                      <label htmlFor='line'>Line</label>
                      <input
                        name='line'
                        value={pole.id?pole.line_name:searchLineText}
                        onChange={e => setSearchLineText(e.target.value)}
                         />
                    </div>
                    <div className={`col-sm-6 col-md-3 d-flex flex-column align-items-center align-items-sm-start justify-content-between pl-sm-4 pl-md-2 pr-md-2 item itemLine ${styles.itemUtility} ${styles.item}`}>
                      <label htmlFor='utils'>Utility</label>
                      <Dropdown
                        name='utils'
                        options={utilsForSearch}
                        onChange={(e) => {
                          if (pole.id) {
                            handleTicketSelectUtility(e);
                          } else {
                            setUtilityForPoleView(e);
                          }
                        }}
                        value={pole.id ? 
                          utilsForSearch.find(u => u.value === pole.utility_id_owning_pole) || utilityForPoleView
                          : 
                          utilityForPoleView
                        }
                        />
                    </div>
                    <div className={`col-sm-6 col-md-3 d-flex flex-column align-items-center align-items-sm-start justify-content-between pl-sm-4 pl-md-2 pr-md-2 item itemDueDate ${styles.item} ${styles.itemDueDate} `}>
                      <label style={{ marginLeft: '10px' }} htmlFor='due_date'>Due Date</label>
                      <input
                        type='date'
                        name='due_date'
                        value={toDateInputValue(dueDate)}
                        onChange={handleDueDateChange}
                        style={{ marginLeft: '10px' }}
                      />
                    </div>
                  </div>
                  <div className={`col-md-2 d-flex flex-column align-items-center align-items-sm-start justify-content-between pl-sm-4 pl-md-2 pr-md-2 item itemLine ${styles.itemLine} ${styles.item}`}>
                      <label>&nbsp;</label>
                      <button
                          style={{ display: ((!pole.id && (searchPoleText || searchLineText )) ? 'block' : 'none') }}
                          type="button"
                          className={`btn text-center w-100 ${saving ? 'btn-disabled' : 'btn-t'}`}
                          onClick={searchPoles}
                          disabled={saving}
                      >
                          Search
                      </button>
                    </div>
                  </div>
                  <div
                    className="row flex-column flex-sm-row section noBorder btnActions"
                  >
                    <div className={needsMerge === true ? ' item block' : ' hidden'}>
                      <p style={{color:"red", width:"100%"}}>This pole has tasks already assigned for work on this job. Merge the tickets or select a different pole.</p>
                      <button type="button" className="btn btn-t text-center w-100" onClick={mergeTickets}>Merge Tickets</button>
                    </div>
                  </div>
            </ErrorBoundary>

            <ErrorBoundary>
            <div className={'row flex-column flex-sm-row section noBorder borderTop'} style={{ display: (pole.id ? 'none' : 'block') }}
                id='Hello there'
            >
                    {/* Table goes here */}
                    {/* <Fade when={potentialPoles}> */}
                    <Section>
                        <div className="col">
                        <div className="detail-section ticket-table-wrapper respTable" hidden={potentialPoles === undefined || potentialPoles.length < 1} >
                            <Table className="table table-striped">
                            <Thead>
                                <Tr>
                                {generateSortableTh('pole_name', 'Pole', ``, sortPoles, setPoleSort, sortPoleAsc, setSortPoleAsc)}
                                {generateSortableTh('line_name', 'Line', ``, sortPoles, setPoleSort, sortPoleAsc, setSortPoleAsc)}
                                {generateSortableTh('substation', 'Substation', ``, sortPoles, setPoleSort, sortPoleAsc, setSortPoleAsc)}
                                {generateSortableTh('substation_curcuit', 'Substation Curcuit', ``, setPoleSort, setPoleSort, sortPoleAsc, setSortPoleAsc)}
                                {generateSortableTh('address', 'Address', ``, sortPoles, setPoleSort, sortPoleAsc, setSortPoleAsc)}
                                {/* <Th scope="col" onClick={() => sortPoleBy('pole_name')}><label>Pole</label> <svg className={(sortPoleAsc==="asc"? "sort-asc" : "sort-desc") + (sortPoles === "pole_name" ? "" : ' hidden')} version="1.1" id="Capa_1" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 292.362 292.362" fill="black"><g><path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424   C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428   s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"/></g></svg></Th>
                                <Th scope="col" onClick={() => sortPoleBy('line_name')}><label>Line</label> <svg className={(sortPoleAsc==="asc"? "sort-asc" : "sort-desc") + (sortPoles === "line_name" ? "" : ' hidden')} version="1.1" id="Capa_1" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 292.362 292.362" fill="black"><g><path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424   C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428   s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"/></g></svg></Th>
                                <Th scope="col">Description</Th> 
                                <Th scope="col" onClick={() => sortPoleBy('substation')}><label>Substation</label> <svg className={(sortPoleAsc==="asc"? "sort-asc" : "sort-desc") + (sortPoles === "assigned_to_name" ? "" : ' hidden')} version="1.1" id="Capa_1" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 292.362 292.362" fill="black"><g><path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424   C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428   s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"/></g></svg></Th>
                                <Th scope="col" onClick={() => sortPoleBy('substation_curcuit')}><label>Substation Curcuit</label> <svg className={(sortPoleAsc==="asc"? "sort-asc" : "sort-desc") + (sort_col === "pole_lat" ? "" : ' hidden')} version="1.1" id="Capa_1" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 292.362 292.362" fill="black"><g><path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424   C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428   s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"/></g></svg></Th>
                                <Th scope="col" onClick={() => sortPoleBy('address')} className='text-center'><label>Street</label> <svg className={(sortPoleAsc==="asc"? "sort-asc" : "sort-desc") + (sort_col === "dig_safe_required" ? "" : ' hidden')} version="1.1" id="Capa_1" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 292.362 292.362" fill="black"><g><path d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424   C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428   s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"/></g></svg></Th>
                                 */}
                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    
                                (potentialPoles && potentialPoles.slice()
                                    .sort((pole1, pole2) => {
                                        let sOpL = sortPoleAsc ? -1 : 1;
                                        let sOpG = sortPoleAsc ? 1 : -1;
                                        if(sortPoles === 'pole_name') {
                                        return pole1.pole_name < pole2.pole_name ? sOpL : sOpG;
                                        } else if(sortPoles === 'line_name') {
                                        return pole1.line_name < pole2.line_name ? sOpL : sOpG;
                                        } else if (sortPoles === 'substation') {
                                        return pole1.sub_curcuit < pole2.sub_curcuit ? sOpL : sOpG;
                                        } else if (sortPoles === 'substation_curcuit') {
                                        return pole1.substation_curciut < pole2.substation_curciut ? sOpL : sOpG;
                                        } else if (sortPoles === 'address') {
                                        return pole1.street_address < pole2.street_address ? sOpL : sOpG;
                                        }
                                        return false;
                                    })
                                    // .filter((p) => {
                                    //     return (pole.pole_name && p.pole_name.toUpperCase().indexOf(pole.pole_name.toUpperCase()) > -1 
                                    //     || pole.line_name && p.line_name.toUpperCase().indexOf(pole.line_name.toUpperCase()) > -1 
                                    //     || pole.sub_curcuit && p.substation.toUpperCase().indexOf(pole.sub_curcuit.toUpperCase()) > -1
                                    //     || pole.sap_curcuit && p.sap_curciut.toString().toUpperCase().indexOf(pole.sap_curcuit.toUpperCase()) > -1)
                                    // })
                                .map((pole) => {
                                    return (
                                    <Tr key={pole.id} className="clickable-row" onClick={() => {changePoleOnTicket(pole)}}>
                                        <Td>{pole.pole_name}</Td>
                                        <Td>{pole.line_name}</Td>
                                        <Td >{pole.sub_curcuit}</Td>
                                        <Td >{pole.sap_curcuit}</Td>
                                        <Td  className='text-center'>{pole.street_address}</Td>
                                    </Tr>
                                    )
                                }))
                                }
                            </Tbody>
                            </Table>
                        </div>
                        
                        </div>
                    </Section>
                    {/* </Fade> */}
                
            </div>
            </ErrorBoundary>

            <ErrorBoundary>
            {!pole.id &&
              <div className={'text-end'} style={{ margin: '20px 4%' }}>
                <button
                  type="button"
                  className={`btn text-center w-25 float-right ${saving ? 'btn-disabled' : 'btn-t'}`}
                  onClick={() => {props.addPole(searchPoleText, searchLineText, utilityForPoleView, dueDate)}}
                  disabled={saving || (!searchLineText || !searchPoleText)}
                >
                  Add as a New Pole
                </button>
                <p className={addPoleError === true ? '' : 'hidden'} style={{color:"red", width:"100%"}}>Error saving pole. Please try again.</p>
              </div>
            }
            </ErrorBoundary>

              <ErrorBoundary> 
                <div className={'row flex-column flex-sm-row section noBorder borderTop'} style={{ display: ((pole.id && needsMerge === false) ? 'block' : 'none') }}>

                  {/* section - Address / Accessibility */}
                  <div className='col'>
                    <div className={`row flex-column flex-sm-row section noBorder ${styles.addressAccessibility}`}>

                        {/* item - Address */}
                        <div className={`col-md-8 d-flex flex-column align-items-start justify-content-between pr-md-2 ${styles.item} ${styles.itemAddress}`}>
                            <label className="label labelTitle" htmlFor="address">Address</label>
                            <input
                            type="text"
                            name="address"
                            value={pole.id && pole.street_address ? pole.street_address: ''}
                            onChange={e=> changePoleAddress(e.target.value)}
                            className={`formItemInput ${styles.formItemInput}`} />
                        </div>

                        {/* item - Accessibility */}
                        <div className={`col-md-4 d-flex flex-column align-items-start justify-content-between pl-md-2 ${styles.item} ${styles.itemAccessibility}`}>
                            <label className="label labelTitle" htmlFor="accessibility">Accessibility</label>
                            <Dropdown
                            options={accessTypesForDropdown ? accessTypesForDropdown : []} 
                            onChange={handleSelectAccessType} 
                            value={pole.id && pole.accessibility_label?pole.accessibility_label:''}
                            //readOnly={ticket && ticket.pole} 
                            placeholder="Access Type" />
                        </div>
                        </div>
                  </div>

                  {/* section - True-X / True-Y */}
                  <div className='col'>
                    <div className="row flex-column flex-sm-row section noBorder trueXY">

                      {/* item - True-x */}
                      <div className={`col-sm-6 d-flex flex-column align-items-start justify-content-between pr-sm-4 pr-md-2 ${styles.item} ${styles.itemTrueX}`}>
                        <label className="label labelTitle" htmlFor="trueX">True-X</label>
                        <input
                          type="text"
                          name="trueX"
                          placeholder="Longitude"
                          className={`formItemInput ${styles.formItemInput}`}
                          value={pole.id && pole.geo_lon ? pole.geo_lon :''}
                          //readOnly={ticket && ticket.pole} 
                          onChange={(e) => longitudeChange(e.target.value)} />
                      </div>

                      {/* item - True-y */}
                      <div className={`col-sm-6 d-flex flex-column align-items-start justify-content-between pl-sm-4 pl-md-2 ${styles.item} ${styles.itemTrueY}`}>
                        <label className="label labelTitle" htmlFor="trueY">True-Y</label>
                        <input
                          type="text"
                          name="trueY"
                          placeholder="Latitude"
                          className={`formItemInput ${styles.formItemInput}`}
                          value={pole.id && pole.geo_lat?pole.geo_lat:''}
                          //readOnly={ticket && ticket.pole} 
                          onChange={(e) => latitudeChange(e.target.value)} />
                      </div>
                    </div>
                  </div>
                        
                  {/* item - Utility Blueprint/Spec */}
                  <div className='col'>
                    <div className='row flex-column flex-sm-row section noBorder'>
                      <div className={`col-12 d-flex flex-column align-items-start justify-content-between ${styles.item}`}>
                        <label className="label labelTitle">Utility Blueprint/Spec</label>
                        <div className="search" style={{ width: '100%' }}>
                          
                            <input
                              value={pole.utility_spec ? pole.utility_spec : ''}
                              onChange={e => setSpecText(e.target.value)} />
                          
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* section - Voltage / Arc Rating */}
                  <div className='col'>
                    <div className="row flex-column flex-sm-row section noBorder voltageArcRAting">

                        {/* item - Primary voltage */}
                        <div className={`col-sm-4 d-flex flex-column align-items-start justify-content-between pr-sm-4 pr-md-2 ${styles.item} ${styles.itemPrimaryVoltage}`}>
                            <label className="label labelTitle" htmlFor="primaryVoltage">Primary Voltage</label>
                            <input
                            type="text"
                            name="primaryVoltage"
                            className={`formItemInput ${styles.formItemInput}`}
                            value={pole.id&&pole.primary_voltage?pole.primary_voltage:''}
                            //readOnly={ticket && ticket.pole} 
                            onChange={(e) => primaryVoltageChange(e.target.value)} />
                        </div>

                        {/* item - Secondary voltage */}
                        <div className={`col-sm-4 d-flex flex-column align-items-start justify-content-between px-sm-4 px-md-2 ${styles.item} ${styles.itemSecondaryVoltage}`}>
                            <label className="label labelTitle" htmlFor="secondaryVoltage">Secondary Voltage</label>
                            <input
                            type="text"
                            name="secondaryVoltage"
                            className={`formItemInput ${styles.formItemInput}`}
                            value={pole.id && pole.secondary_voltage ? pole.secondary_voltage : ''}
                            //readOnly={ticket && ticket.pole} 
                            onChange={(e) => secondaryVoltageChange(e.target.value)} />
                        </div>

                        {/* item - Arc rating */}
                        <div className={`col-sm-4 d-flex flex-column align-items-start justify-content-between pl-sm-4 pl-md-2 ${styles.item} ${styles.itemArcRating}`}>
                            <label className="label labelTitle" htmlFor="arcRating">Arc Rating</label>
                            <input
                            type="text"
                            name="arcRating"
                            className={`formItemInput ${styles.formItemInput}`}
                            value={pole.id && pole.arc_rating ? pole.arc_rating : ''}
                            //readOnly={poleInProgress} 
                            onChange={(e) => arcRatingChange(e.target.value)} />
                        </div>

                        </div>
                  </div>

                    {/* section - btnActions */}
                    <div className="row flex-column flex-sm-row section btnActions">
                        <div className="col-sm-4 offset-sm-8 item">
                            <button 
                                style={{ display: ((pole.id && (activePoleDirty)) ? 'block' : 'none') }} 
                                type="button" 
                                className="btn btn-t text-center w-100" 
                                onClick={savePole}>Save Pole</button>
                        </div>
                    </div>
                </div>
                </ErrorBoundary>
            </div>

    );
}

export default TicketHome